import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, mobileIs, loadScrollMagic } from "../../utils/siteUtils";
import { Icon, PrimaryButton } from "../../elements";
import gsap from 'gsap';
import "./style.scss";
import Swiper from 'swiper';

const WtcrContent = ({ page, lang, rendering, fields }) => {
  const isAR = page?.fields?.rtl?.value;
  const {
    pcTitle,
    mTitle,
    pcSubTitle,
    mSubTitle,
    mlist,
    pclist,
    duration,
    button
  } = fields;
  const isMobile = mobileIs()
  const rootNode = useRef(null)
  const mainId = `c-wtcr-content${rendering.uid}`
  const [datalist, setDatalist] = useState([])
  const [animateData, setAnimateData] = useState([])
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isActive, setIsActive] = useState(false)
  const [isMoveBack, setIsMoveBack] = useState(false)
  const [firstAnimateStart, setFirstAnimateStart] = useState(false)
  const [firstAnimateEnd, setFirstAnimateEnd] = useState(false)
  const [secondAnimateStart, setSecondAnimateStart] = useState(false)
  const [progress, setProgress] = useState(null)
  const [scrollDirection, setScrollDirection] = useState(null)
  const [reverseFirstAnimation, setReverseFirstAnimation] = useState(false)
  
  let textTime = 10
  let textTimeMobile = 30
  let newsIndex = 0
  let txtIndex = 0
  let hideTxtIndex = 0
  if(isMobile) {
    hideTxtIndex = mSubTitle.value.length
  } else {
    hideTxtIndex = pcSubTitle.value.length
  }
  let txtTimer
  
  const getNewsArrDefault = () => {
    let newsArr =  []//打字输出的内容
    if(isMobile) {
      newsArr.push(mSubTitle.value)
    } else {
      newsArr.push(pcSubTitle.value)
    }
    return newsArr
  }
  const [newsArr, setNewArr] = useState(() => getNewsArrDefault());
  const swiper = useRef(null)
  const swiperEl = useRef(null)

  const getListData = () => {
    let datalist = []
    if(isMobile) {
      mlist.map((item, index) => {
        if(item.fields?.isShow.value) {
          datalist.push(item)
        }
      })
    } else {
      pclist.map((item, index) => {
        if(item.fields?.isShow.value) {
          datalist.push(item)
        }
      })
    }
    setDatalist(datalist)
  }

  const getMAnimateData = () => {
    let swiperData = [] // 轮播图所有图片
    let swiperWallData = [] // 照片墙轮播的图片 第二排
    let otherData = [] // 照片墙除轮播图片以外的其余图片集合
    mlist.map((item, index) => {
      if(item.fields?.title?.value && item.fields?.desc?.value) {
        swiperData.push(item)
      }
    })
    let last = swiperData.pop(); //取数组最后一项
    swiperData.unshift(last); //插入数组第一位
    swiperData.map((item, index) => {
      if(index < 3) {
        swiperWallData.push(item)
      }
    })
    mlist.map((item, index) => {
      if(item.id != swiperWallData[0].id && item.id != swiperWallData[1].id && item.id != swiperWallData[2].id) {
        otherData.push(item)
      }
    })
    let animateData = getNewArray(otherData, 3)
    animateData.splice(1, 0, swiperWallData)
    setAnimateData(animateData)
  }

  const getPcAnimateData = () => {
    let swiperData = [] // 轮播图所有图片
    let swiperWallData = [] // 照片墙轮播的图片 第二排
    let otherData = [] // 照片墙除轮播图片以外的其余图片集合
    pclist.map((item, index) => {
      if(item.fields?.title?.value && item.fields?.desc?.value) {
        swiperData.push(item)
      }
    })
    let last = swiperData.pop(); //取数组最后一项
    swiperData.unshift(last); //插入数组第一位
    if(!isAR) {
      let last2 = swiperData.pop(); //取数组最后一项
      swiperData.unshift(last2); //插入数组第一位
      let last3 = swiperData.pop(); //取数组最后一项
      swiperData.unshift(last3); //插入数组第一位
    }
    swiperData.map((item, index) => {
      if(index < 5) {
        swiperWallData.push(item)
      }
    })
    pclist.map((item, index) => {
      if(item.id != swiperWallData[0].id && item.id != swiperWallData[1].id && item.id != swiperWallData[2].id && item.id != swiperWallData[3].id && item.id != swiperWallData[4].id) {
        otherData.push(item)
      }
    })
    let animateData = getNewArray(otherData, 5)
    animateData.splice(1, 0, swiperWallData)
    setAnimateData(animateData)
  }

  const getNewArray = (array, subGroupLength) => {
    let index = 0;
    let newArray = [];
    while (index < array.length) {
      newArray.push(array.slice(index, (index += subGroupLength)));
    }
    return newArray;
  }

  // magicScoll 初始化
  const initMagicScroll = () => {
    let ScrollMagic = loadScrollMagic();
    let tl = gsap.timeline();
    let controller = new ScrollMagic.Controller();
    let scene = new ScrollMagic.Scene({
      triggerElement: rootNode.current,
      triggerHook: "onLeave",
      duration: "100%"
    }).setPin(`#${mainId}`).setTween(tl).addTo(controller);

    scene.on("progress", function(event) {
      setProgress(event.progress)
    });
    return () => {
      scene.destroy(true)
      scene = null
      controller.destroy(true)
      controller = null
    }
  }

  // PC端动画
  const pcTextAnimate = () => {
    showText()
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight
    let wait = pcSubTitle.value.length * 18
    document.body.style.overflowY = "hidden";
    //初始化照片墙
    let wallOneDoms = document.querySelectorAll('.pc-item-content .one') // 照片墙dom集合
    let wallTwoDoms = document.querySelectorAll('.pc-item-content .two') // 照片墙dom集合
    let wallThreeDoms = document.querySelectorAll('.pc-item-content .three') // 照片墙dom集合
    let wallFourDoms = document.querySelectorAll('.pc-item-content .four') // 照片墙dom集合
    let wallFiveDoms = document.querySelectorAll('.pc-item-content .five') // 照片墙dom集合
    for(let i=0;i<wallOneDoms.length;i++) {
      wallOneDoms[i].style.transform = 'translateY(35vh)'
    }
    for(let i=0;i<wallTwoDoms.length;i++) {
      wallTwoDoms[i].style.transform = 'translateY(10vh)'
    }
    for(let i=0;i<wallThreeDoms.length;i++) {
      wallThreeDoms[i].style.transform = 'translateY(35vh)'
    }
    for(let i=0;i<wallFourDoms.length;i++) {
      wallFourDoms[i].style.transform = 'translateY(10vh)'
    }
    for(let i=0;i<wallFiveDoms.length;i++) {
      wallFiveDoms[i].style.transform = 'translateY(35vh)'
    }
    let animateContentDom = document.querySelector('.animate-content')
    setTimeout((e) => {
      let textContentDom = document.querySelector('.text-content')
      textContentDom.style.opacity = '0'
      animateContentDom.style.opacity = '1'
      let fontSize = 100
      if(pageWidth < 1367) {
        fontSize = 70
      } else if(pageWidth > 1366 && pageWidth < 1900) {
        fontSize = 70
      }
      let scale = 2 // 轮播图片与照片墙图片的比例
      let animateContent = document.querySelector('.animate-content')
      let wallDoms = document.querySelectorAll('.pc-item-content .item') // 照片墙dom集合
      let everyDoms = document.querySelectorAll('.pc-item-content') // 所有行数包裹dom集合 PC端3行
      let imageW = 7.8 * fontSize / scale
      let imageH = 5.2 * fontSize / scale
      for(let i=0;i<wallDoms.length;i++) {
        wallDoms[i].style.width = imageW + 'px'
        wallDoms[i].style.height = imageH + 'px'
      }
      setTimeout((e) => { // 暂时写在定时器中，应该是滚动后执行的
        setIsMoveBack(true) // 该动画执行时间为1s
        for(let i=0;i<wallOneDoms.length;i++) {
          wallOneDoms[i].style.transform = 'translateY(40px)'
        }
        for(let i=0;i<wallTwoDoms.length;i++) {
          wallTwoDoms[i].style.transform = 'translateY(0)'
        }
        for(let i=0;i<wallThreeDoms.length;i++) {
          wallThreeDoms[i].style.transform = 'translateY(40px)'
        }
        for(let i=0;i<wallFourDoms.length;i++) {
          wallFourDoms[i].style.transform = 'translateY(0)'
        }
        for(let i=0;i<wallFiveDoms.length;i++) {
          wallFiveDoms[i].style.transform = 'translateY(40px)'
        }
        setTimeout(v=>{
          document.body.style.overflowY = "auto";
        },1000)
      }, 600)
      setTimeout((e) => {
        textContentDom.style.opacity = 0
        textContentDom.style.height = 0
        setTimeout(v=>{
          // textContentDom.style.display = 'none'
        })
        setTimeout(() => {
          setFirstAnimateEnd(true)
        }, 2000);
      })
    }, wait)
  }

  // M端动画
  const mTextAnimate = (index) => { // m 文案动效
    showText()
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight
    let scale = ((pageWidth - 40) * 0.7) / ((pageHeight - 154) / 4) // 轮播图片与照片墙图片的比例
    document.body.style.overflowY = "hidden";
    //初始化照片墙
    setIsMoveBack(false)
    let wallDoms = document.querySelectorAll('.m-item-content .item') // 照片墙dom集合
    let wallContentDom = document.querySelector('.m-image-animate') // 照片墙包裹层dom
    let everyDoms = document.querySelectorAll('.m-item-content') // 所有行数包裹dom集合 移动端4行
    let leftDom = document.querySelector('.m-item-content .left') // 第二排第1个
    let centerDom = document.querySelector('.m-item-content .center') // 第二排第2个
    let rightDom = document.querySelector('.m-item-content .right') // 第二排第3个
    let wrapDom = document.querySelector('.c-wtcr-content_wrapper')
    leftDom.style.transform = 'translateY(50vh)'
    rightDom.style.transform = 'translateY(70vh)'
    centerDom.style.top = '60vh'
    let imageW = (pageWidth - 40) / scale
    let imageH = (pageWidth - 40) * 0.7 / scale
    for(let i=0;i<wallDoms.length;i++) {
      wallDoms[i].style.width = imageW + 'px'
      wallDoms[i].style.height = imageH + 'px'
    }

    let wait = isMobile ? mSubTitle.value.length * 35 : mSubTitle.value.length * 12
    // 后面的文案动效也需要延迟执行
    setTimeout((e) => {
      let textContentDom = document.querySelector('.text-content')
      textContentDom.style.opacity = '0'
      wallContentDom.style.opacity = '1'
      setTimeout((e) => {
        wrapDom.scrollLeft = ((pageWidth - 40) / scale * 3 + 52 - pageWidth) / 2;
      }, 500)
      setTimeout((e) => { // 暂时写在定时器中，应该是滚动后执行的
        setIsMoveBack(true) // 该动画执行时间为1s
        leftDom.style.transform = 'translateY(20px)'
        centerDom.style.top = '60px'
        rightDom.style.transform = 'translateY(20px)'
        setTimeout(v=>{
          document.body.style.overflowY = "auto";
        },1000)
      }, 600)
      setTimeout((e) => {
        textContentDom.style.opacity = 0
        textContentDom.style.height = 0
        setTimeout(v=>{
          // textContentDom.style.display = 'none'
        })
        setFirstAnimateEnd(true)
      }, 2000)
    }, wait)
  }

  // 第二次滚动动画 正向
  const secondAnimate = () => {
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight
    if(isMobile) {
      let everyDoms = document.querySelectorAll('.m-item-content') // 所有行数包裹dom集合 移动端4行
      let leftDom = document.querySelector('.m-item-content .left') // 第二排第1个
      let centerDom = document.querySelector('.m-item-content .center') // 第二排第2个
      let rightDom = document.querySelector('.m-item-content .right') // 第二排第3个
      let scale = ((pageWidth - 40) * 0.7) / ((pageHeight - 154) / 4) // 轮播图片与照片墙图片的比例
      let imageW = (pageWidth - 40) / scale
      let imageH = (pageWidth - 40) * 0.7 / scale
      // 除swiper照片以外 其余的全部渐隐
      everyDoms[0].style.transform = 'translateX(-150vw) translateY(-25vh)'
      everyDoms[0].style.opacity = '0'
      everyDoms[2].style.transform = 'translateX(150vw) translateY(50vh)'
      everyDoms[2].style.opacity = '0'
      everyDoms[3].style.transform = 'translateX(300vw) translateY(100vh)'
      everyDoms[3].style.opacity = '0'
      
      if(isAR) {
        leftDom.style.transform = 'translateX(100vw)'
        rightDom.style.transform = 'translateX(-100vw)'
      } else {
        leftDom.style.transform = 'translateX(-100vw)'
        rightDom.style.transform = 'translateX(100vw)'
      }
      centerDom.style.transform = 'scale('+ scale +')'
      centerDom.style.top = -24 - imageH + (scale - 1)/2 * imageH + 100 +'px'
      leftDom.style.opacity = '0'
      rightDom.style.opacity = '0'
      setTimeout((e) => {
        setIsActive(true)
      }, 1000)
    } else {
      let fontSize = 100
      if(pageWidth < 1367) {
        fontSize = 70
      } else if(pageWidth > 1366 && pageWidth < 1900) {
        fontSize = 70
      }
      let scale = 2
      let wallDoms = document.querySelectorAll('.pc-item-content .item') // 照片墙dom集合
      let everyDoms = document.querySelectorAll('.pc-item-content') // 所有行数包裹dom集合 PC端3行
      let Y = Math.round(((pageHeight - fontSize * 5.2) / 2 - 0.1 * pageHeight))
      everyDoms[0].style.transform = 'scale(' + scale + ') translateX(-150vw) translateY(-30vh)'
      everyDoms[0].style.opacity = '0'
      let translateX = (7.8 * fontSize + 100) / 2 * -1
      if(isAR) {
        translateX = (7.8 * fontSize + 100) / 2 * -1 - 3
      }
      everyDoms[1].style.transform = 'scale(' + scale + ') translateX('+ translateX +'px) translateY(' + Y/-2 +'px)'
      everyDoms[2].style.transform = 'scale(' + scale + ') translateX(150vw) translateY(30vh)'
      everyDoms[2].style.opacity = '0'
      for(let i=0;i<wallDoms.length;i++) {
        wallDoms[i].style.transform = 'translateY(0)'
      }
      setTimeout((e) => {
        setIsActive(true)
        // swiper.current.autoplay.start()
      }, 1500)
    }
  }

  // 第一次动画 逆向
  const reverseFirstAnimate = () => {
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight
    if(isMobile) {
      setIsActive(false)
      setTimeout((e) => {
        let everyDoms = document.querySelectorAll('.m-item-content') // 所有行数包裹dom集合 移动端4行
        let leftDom = document.querySelector('.m-item-content .left') // 第二排第1个
        let centerDom = document.querySelector('.m-item-content .center') // 第二排第2个
        let rightDom = document.querySelector('.m-item-content .right') // 第二排第3个
        let scale = ((pageWidth - 40) * 0.67) / ((pageHeight - 154) / 4) // 轮播图片与照片墙图片的比例
        let imageW = (pageWidth - 40) / scale
        let imageH = (pageWidth - 40) * 0.67 / scale
        centerDom.style.transform = 'scale('+ 1 +')'
        centerDom.style.top = '60px'
        leftDom.style.opacity = '1'
        rightDom.style.opacity = '1'
        leftDom.style.transform = 'translateX(0) translateY(20px)'
        rightDom.style.transform = 'translateX(0) translateY(20px)'
        // 除swiper照片以外 其余的全部渐隐
        everyDoms[0].style.transform = 'translateX(0) translateY(0)'
        everyDoms[0].style.opacity = '1'
        everyDoms[2].style.transform = 'translateX(0) translateY(0)'
        everyDoms[2].style.opacity = '1'
        everyDoms[3].style.transform = 'translateX(0) translateY(0)'
        everyDoms[3].style.opacity = '1'
        setReverseFirstAnimation(true)
      }, 100)
    } else {
      let fontSize = 100
      if(pageWidth < 1367) {
        fontSize = 70
      } else if(pageWidth > 1366 && pageWidth < 1900) {
        fontSize = 70
      }
      let scale = 2
      setIsActive(false)
      setTimeout((e) => {
        let wallOneDoms = document.querySelectorAll('.pc-item-content .one') // 照片墙dom集合
        let wallTwoDoms = document.querySelectorAll('.pc-item-content .two') // 照片墙dom集合
        let wallThreeDoms = document.querySelectorAll('.pc-item-content .three') // 照片墙dom集合
        let wallFourDoms = document.querySelectorAll('.pc-item-content .four') // 照片墙dom集合
        let wallFiveDoms = document.querySelectorAll('.pc-item-content .five') // 照片墙dom集合
        let everyDoms = document.querySelectorAll('.pc-item-content') // 所有行数包裹dom集合 PC端3行
        let Y = Math.round(((pageHeight - fontSize * 5.2) / 2 - 0.1 * pageHeight))
        everyDoms[0].style.transform = 'scale(' + 1 + ') translateX(0) translateY(0)'
        everyDoms[0].style.opacity = '1'
        everyDoms[1].style.transform = 'scale(1) translateX(0px) translateY(0px)'
        everyDoms[2].style.transform = 'scale(1) translateX(0) translateY(0)'
        everyDoms[2].style.opacity = '1'
        for(let i=0;i<wallOneDoms.length;i++) {
          wallOneDoms[i].style.transform = 'translateY(40px)'
        }
        for(let i=0;i<wallTwoDoms.length;i++) {
          wallTwoDoms[i].style.transform = 'translateY(0)'
        }
        for(let i=0;i<wallThreeDoms.length;i++) {
          wallThreeDoms[i].style.transform = 'translateY(40px)'
        }
        for(let i=0;i<wallFourDoms.length;i++) {
          wallFourDoms[i].style.transform = 'translateY(0)'
        }
        for(let i=0;i<wallFiveDoms.length;i++) {
          wallFiveDoms[i].style.transform = 'translateY(40px)'
        }
        setReverseFirstAnimation(true)
      }, 100)
    }
  }

  // 第二次动画 逆向
  const reverseSecondAnimate = () => {
    if(isMobile) {
      let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
      let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight
      let scale = ((pageWidth - 40) * 0.7) / ((pageHeight - 154) / 4) // 轮播图片与照片墙图片的比例
      let wallDoms = document.querySelectorAll('.m-item-content .item') // 照片墙dom集合
      let wallContentDom = document.querySelector('.m-image-animate') // 照片墙包裹层dom
      let everyDoms = document.querySelectorAll('.m-item-content') // 所有行数包裹dom集合 移动端4行
      let textContentDom = document.querySelector('.text-content')
      let leftDom = document.querySelector('.m-item-content .left') // 第二排第1个
      let centerDom = document.querySelector('.m-item-content .center') // 第二排第2个
      let rightDom = document.querySelector('.m-item-content .right') // 第二排第3个
      setFirstAnimateEnd(false)
      // textContentDom.style.display = 'flex'
      setIsMoveBack(true)
      leftDom.style.transform = 'translateY(20px)'
      centerDom.style.top = '60px'
      rightDom.style.transform = 'translateY(20px)'
      setTimeout((e) => {
        // textContentDom.style.opacity = '1'
        // wallContentDom.style.opacity = '0'
        // hideText()
      }, 1000)
    } else {
      let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
      let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight
      let textContentDom = document.querySelector('.text-content')
      let wallContentDom = document.querySelector('.animate-content')
      let animateContentDom = document.querySelector('.animate-content')
      let wallOneDoms = document.querySelectorAll('.pc-item-content .one') // 照片墙dom集合
      let wallTwoDoms = document.querySelectorAll('.pc-item-content .two') // 照片墙dom集合
      let wallThreeDoms = document.querySelectorAll('.pc-item-content .three') // 照片墙dom集合
      let wallFourDoms = document.querySelectorAll('.pc-item-content .four') // 照片墙dom集合
      let wallFiveDoms = document.querySelectorAll('.pc-item-content .five') // 照片墙dom集合
      for(let i=0;i<wallOneDoms.length;i++) {
        wallOneDoms[i].style.transform = 'translateY(40px)'
      }
      for(let i=0;i<wallTwoDoms.length;i++) {
        wallTwoDoms[i].style.transform = 'translateY(0)'
      }
      for(let i=0;i<wallThreeDoms.length;i++) {
        wallThreeDoms[i].style.transform = 'translateY(40px)'
      }
      for(let i=0;i<wallFourDoms.length;i++) {
        wallFourDoms[i].style.transform = 'translateY(0)'
      }
      for(let i=0;i<wallFiveDoms.length;i++) {
        wallFiveDoms[i].style.transform = 'translateY(40px)'
      }
      setFirstAnimateEnd(false)
      // textContentDom.style.display = 'flex'
      setIsMoveBack(false)
      setTimeout((e) => {
        // textContentDom.style.opacity = '1'
        // wallContentDom.style.opacity = '0'
        // hideText()
      }, 1000)
    }
  }
  // 文案动效
  const showText = () => {
    let newStr = newsArr[newsIndex]
    if (txtIndex >= newStr.length) {
      clearInterval(txtTimer) //一旦超过要显示的文字长度，清除对shownew()的周期性调用
      newsIndex++
      if (newsIndex >= newsArr.length) {
        return false
      }
      txtIndex = 0
      return
    }
    clearInterval(txtTimer)
    document.querySelector('.sub-title').innerHTML = newStr.substring(0, txtIndex + 1)
    txtIndex ++
    txtTimer = setInterval(showText, isMobile ? textTimeMobile : textTime)
  }
  // 文案动效逆向
  const hideText = () => {
    let newStr = newsArr[newsIndex]
    if (hideTxtIndex <= 0) {
      clearInterval(txtTimer) //一旦超过要显示的文字长度，清除对shownew()的周期性调用
      newsIndex++
      if (newsIndex >= newsArr.length) {
        return false
      }
      hideTxtIndex = newStr.length
      return
    }
    clearInterval(txtTimer)
    document.querySelector('.sub-title').innerHTML = newStr.substring(0, hideTxtIndex-1)
    hideTxtIndex --
    txtTimer = setInterval(hideText, textTime)
  }

  // 初始化轮播图
  const buildSwiper = () => {
    const options = {
      loop: true,
      watchSlidesProgress: true,
      slidesPerView: isMobile ? 1 : 'auto',
      spaceBetween: isMobile ? 0 : 100,
      centeredSlides: isMobile ? false : true,
      navigation: {
        nextEl: ".swiper-button-prev",
        prevEl: ".swiper-button-next",
      },
      on:{
        slideChangeTransitionStart(swiper) {
          let realIndex = swiper.realIndex
          setCurrentIndex(realIndex)
        }, 
      },
    }
    swiper.current = new Swiper(swiperEl.current, options);
  }

  useEffect(() => {
    if(progress > 0) {
      setFirstAnimateStart(true)
    } else {
      setFirstAnimateStart(false)
    }

    if(progress > 0.6 && firstAnimateEnd) {
      setSecondAnimateStart(true)
    } else {
      setSecondAnimateStart(false)
    }
  }, [progress, firstAnimateEnd])

  useEffect(() => {
    if(firstAnimateStart) {
      if(isMobile) {
        mTextAnimate(0)
      } else {
        pcTextAnimate()
      }
    }
  }, [firstAnimateStart])

  useEffect(() => {
    // 正向动画
    if(secondAnimateStart && firstAnimateEnd) {
      secondAnimate()
    }
  }, [secondAnimateStart, firstAnimateEnd])

  useEffect(() => {
    // 逆向动画
    if(!secondAnimateStart && isActive) {
      reverseFirstAnimate()
    }
  }, [secondAnimateStart, isActive])

  useEffect(() => {
    // 逆向动画
    if(!firstAnimateStart && !isActive && reverseFirstAnimation) {
      reverseSecondAnimate()
    }
  }, [firstAnimateStart, isActive, reverseFirstAnimation])


  useEffect(() => {
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
    let progressWidth = isMobile ? pageWidth - 40 : 900
    let listlength = datalist.length
    let dwidth = progressWidth / listlength
    document.querySelector('.swiper-progress').style.width = ((currentIndex + 1)/listlength) * progressWidth + 'px'
  }, [datalist, currentIndex])
  
  useEffect(() => {
    initMagicScroll()
    getListData()
    if(isMobile) {
      getMAnimateData()
    } else {
      getPcAnimateData()
    }
    setTimeout((e) => {
      buildSwiper();
    }, 100)
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    }
  }, [])

  const onScroll = () => {
    if(rootNode.current ){
      let top = rootNode.current.getBoundingClientRect().top;
      let textContentDom = document.querySelector('.text-content')
      let wallContentDom = isMobile ?  document.querySelector('.m-image-animate') : document.querySelector('.animate-content')
      if(top > window.innerHeight ){
        textContentDom.style.opacity = '1'
        textContentDom.style.height = '100%'
        wallContentDom.style.opacity = '0'
        textContentDom.style.display = 'flex'
        let newStr = newsArr[newsIndex]
        document.querySelector('.sub-title').innerHTML = newStr.substring(0, 0)
      }
    }
  }
  const rootClasses = classNames("c-wtcr-content", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode}>
      <div className="c-wtcr-content_wrapper" id={mainId}>
        <div className="text-content">
          <RichText tag="div" className="title" field={isMobile ? mTitle : pcTitle} />
          <div className="sub-title"></div>
        </div>
        <div className="image-wall">
          <div className={["c-wtcr-content_swiper swiper", isActive ? 'active' : ''].join(' ')} ref={swiperEl}>
            <div className="swiper-wrapper">
              {datalist && datalist.map((item, index) => (
                <div className="swiper-slide" key={index}>
                  <div className={["story-image", isActive ? 'active' : ''].join(' ')} style={{ backgroundImage: `url(${item?.fields?.image?.value?.src})` }}></div>
                  <RichText tag="div" className="story-title" field={item?.fields?.title} />
                  <RichText tag="div" className="story-desc" field={item?.fields?.desc} />
                </div>
              ))}
            </div>
            {button && <div className="learn-button">
              <PrimaryButton {...button?.fields} />
            </div>}
            <div className="swiper-button-content">
              <div className="swiper-button-next">
                <Icon name="ArrowBack" className="c-wtcr-content__left" />
              </div>
              <div className="swiper-button-prev">
                <Icon name="ArrowForward" className="c-wtcr-content__right" />
              </div>
            </div>
            <div className="progress-content">
              <div className="swiper-progress"></div>
            </div>
          </div>
        </div>
        <div className={["m-image-animate", isActive ? 'active' : ''].join(' ')}>
          {animateData && animateData.map((option, i) => {
            return (
              <div className="m-item-content" key={i}>
                {option && option.map((item, index) => {
                  return (
                    <div style={{ backgroundImage: `url(${item?.fields?.image?.value?.src})` }} className={["item", index === 0 ? 'one' : '', index === 1 ? 'two' : '', index === 2 ? 'three' : '', isMoveBack ? 'back' : '', i === 1 && index === 0 ? 'left' : '', i === 1 && index === 1 ? 'center' : '', i === 1 && index === 2 ? 'right' : ''].join(' ')} key={index}></div>
                  )
                })}
              </div>
            )
          })}
        </div>
        <div className={["animate-content", isActive ? 'active' : ''].join(' ')}>
          <div className="pc-image-animate">
            {animateData && animateData.map((option, i) => {
              return (
                <div className="pc-item-content" key={i}>
                  {option && option.map((item, index) => {
                    return (
                      <div style={{ backgroundImage: `url(${item?.fields?.image?.value?.src})` }} className={["item", index === 0 ? 'one' : '', index === 1 ? 'two' : '', index === 2 ? 'three' : '', index === 3 ? 'four' : '', index === 4 ? 'five' : '', isMoveBack ? 'back' : ''].join(' ')} key={index}></div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WtcrContent;